import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

function extractText(node) {
  if (node == null) return "";
  if (typeof node === "string") return node;
  if (typeof node === "number" || typeof node === "boolean") return String(node);
  if (Array.isArray(node)) return node?.map(extractText)?.filter(Boolean)?.join(" ");
  if (node?.props !== undefined) return extractText(node?.props?.children);
  return String(node);
}

function cellValue(col, record) {
  const val = col?.render?.(record);
  if (val == null) return "";
  if (typeof val === "string" || typeof val === "number") return val;
  return extractText(val);
}

function escapeCSV(v) {
  const s = String(v ?? "");
  return s?.includes(",") || s?.includes('"') || s?.includes("\n")
    ? `"${s?.replace(/"/g, '""')}"`
    : s;
}

export function downloadCSV(data, columns, filename) {
  const headers = columns?.map((c) => c?.title ?? "");
  const rows = (data ?? [])?.map((record) =>
    columns?.map((col) => cellValue(col, record)),
  );
  const csv = [
    headers?.map(escapeCSV)?.join(","),
    ...rows?.map((row) => row?.map(escapeCSV)?.join(",")),
  ]?.join("\n");
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
  saveAs(blob, filename);
}

export function downloadJSON(data, filename) {
  const blob = new Blob([JSON.stringify(data ?? [], null, 2)], {
    type: "application/json",
  });
  saveAs(blob, filename);
}

export function downloadExcel(data, columns, filename) {
  const headers = columns?.map((c) => c?.title ?? "");
  const rows = (data ?? [])?.map((record) =>
    columns?.map((col) => cellValue(col, record)),
  );
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, filename);
}

export function triggerDownload(format, data, columns, baseName) {
  const date = moment()?.format("YYYY-MM-DD");
  if (format === "csv") downloadCSV(data, columns, `${baseName}-${date}.csv`);
  else if (format === "json") downloadJSON(data, `${baseName}-${date}.json`);
  else if (format === "excel") downloadExcel(data, columns, `${baseName}-${date}.xlsx`);
}
